export default "__VITE_ASSET__CQrNxlJU__"